/**
 * Shared `data-testid` constants used by `@sib/ui` components and the
 * SpendBrain app so test selectors stay aligned with the component output.
 */
export const FILE_PREVIEW_ROOT_TEST_ID = 'file-preview' as const;
export const FILE_MANAGER_DROPZONE_TEST_ID = 'file-dropzone' as const;
export const CONFIRM_FILES_UPLOAD_TEST_ID =
  'confirm-files-upload-button' as const;

/**
 * Suffix tokens appended to a base `data-testid` by `TableTextInput`.
 *
 * @example
 * // Component applies: `${baseId}-${TableTextInputSuffix.Edit}`
 * // Selector targets: `[data-testid="${TestIds.DocumentFilenameEditor}-edit"]`
 */
export enum TableTextInputSuffix {
  Edit = 'edit',
  Input = 'input',
  Confirm = 'confirm',
  Cancel = 'cancel',
}
